import { useAppStateSelector } from '../useAppStateSelector'
import { LoadingStates } from '@dashboard/lib/types'
import { useAppDispatch } from '../useAppDispatch'
import { loadMe } from '@dashboard/store/actions/user/me'

interface Props {
  state: LoadingStates
  fetch: () => void
}

export function useLoadAuthUser(): Props {
  const { meState } = useAppStateSelector(state => state.user)
  const state = meState
  const dispatch = useAppDispatch()
  const fetch = () => dispatch(loadMe())

  return {
    state,
    fetch,
  }
}
